import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button/button';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useEffect, useState } from 'react';
import { Horizontal } from "../../../../utils/layouts";
import { TranslationsKeys } from '../util';
import styles from './reset-password-confirmation-modal.module.scss';
export const ResetPasswordConfirmationModal = ({ onResetConfirm, onModalClose, onGenerateOtp, isModalOpen, generatedOtp = '', showLoader = false, showOtpLoader = false, otpErrorMessage = '', }) => {
    const { t } = useTranslation();
    const [hasClickedGenerate, setHasClickedGenerate] = useState(false);
    const [localOtp, setLocalOtp] = useState('');
    const [showOtpError, setShowOtpError] = useState(false);
    useEffect(() => {
        if (isModalOpen) {
            setHasClickedGenerate(false);
            setLocalOtp('');
            setShowOtpError(false);
        }
    }, [isModalOpen]);
    useEffect(() => {
        if (isModalOpen && !localOtp && generatedOtp) {
            setLocalOtp(generatedOtp);
        }
    }, [isModalOpen, generatedOtp, localOtp]);
    useEffect(() => {
        if (otpErrorMessage) {
            setShowOtpError(true);
        }
    }, [otpErrorMessage]);
    return (React.createElement(Modal, { size: ModalSize.SMALL, title: t(TranslationsKeys.RESET_PASSWORD), isOpen: isModalOpen, confirmButton: {
            text: TranslationsKeys.DONE,
            onConfirm: onResetConfirm,
            isLoading: showLoader,
        }, onDismiss: onModalClose },
        React.createElement(Vertical, { className: styles.modalContent },
            React.createElement(Vertical, { className: styles.modalBody },
                React.createElement(Typography, { variant: "p", noMargin: true, className: styles.warningText }, t(TranslationsKeys.OTP_WARNING)),
                showOtpError && (React.createElement(Typography, { variant: "footnote", className: styles.infoText }, t(TranslationsKeys.OTP_GENERATION_FAILED))),
                localOtp && (React.createElement(Typography, { variant: "footnote", className: styles.infoText }, t(TranslationsKeys.OTP_USAGE))),
                React.createElement(Horizontal, { vAlignContent: "center", className: styles.otpSection },
                    !localOtp && (React.createElement(Button, { onClick: () => {
                            setHasClickedGenerate(true);
                            onGenerateOtp();
                        }, isDisabled: hasClickedGenerate || showOtpLoader, type: "secondary", size: "s", text: t(TranslationsKeys.EXPIRE_PASSWORD), className: styles.generateButton })),
                    showOtpLoader ? (React.createElement(LoadingIndicator, null)) : (localOtp && (React.createElement(Input.Text, { value: localOtp, readOnly: true, placeholder: "OTP", className: styles.otpInput }))))))));
};
//# sourceMappingURL=reset-password-confirmation-modal.js.map